import React from 'react';
import { ArticlesInquiriesQueryProvider } from './list/ArticlesInquiriesQueryProvider';

export const ArticlesInquiriesProviders = ({ children }: any) => {
	return <ArticlesInquiriesQueryProvider>{children}</ArticlesInquiriesQueryProvider>;
};
